var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareGroupCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5429_2351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.12847 9.96635C9.44223 10.5813 9.19808 11.3341 8.58314 11.6479C7.9682 11.9617 7.21535 11.7175 6.90159 11.1026C5.92454 9.18764 6.27742 6.83849 7.82108 5.29483L10.4727 2.64318C12.4253 0.690556 15.5912 0.690556 17.5438 2.64318C19.4964 4.5958 19.4964 7.76162 17.5438 9.71424C17.0556 10.2024 16.2642 10.2024 15.776 9.71424C15.2879 9.22609 15.2879 8.43463 15.776 7.94648C16.7523 6.97017 16.7523 5.38725 15.776 4.41094C14.7997 3.43463 13.2168 3.43463 12.2405 4.41094L9.58884 7.06259C8.81695 7.83449 8.6404 9.00978 9.12847 9.96635ZM11.0617 10.2175C10.7479 9.60251 10.9921 8.84966 11.607 8.5359C12.2219 8.22214 12.9748 8.4663 13.2886 9.08123C14.2656 10.9962 13.9127 13.3453 12.3691 14.889L9.71742 17.5406C7.7648 19.4932 4.59897 19.4932 2.64635 17.5406C0.693729 15.588 0.693729 12.4222 2.64635 10.4696C3.13451 9.9814 3.92596 9.9814 4.41412 10.4696C4.90227 10.9577 4.90227 11.7492 4.41412 12.2373C3.43781 13.2136 3.43781 14.7965 4.41412 15.7729C5.39043 16.7492 6.97334 16.7492 7.94965 15.7729L10.6013 13.1212C11.3732 12.3493 11.5497 11.174 11.0617 10.2175Z",
    fill: "#AC92ED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5429_2351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareGroupCall);
export default __webpack_public_path__ + "static/media/share_group_call.91a80c7e3fc5ccf893a274a358161f0d.svg";
export { ForwardRef as ReactComponent };